var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg39Bdbd3D6Dd984Bb089Adc962360313Ddb8583124Ff2D09951Ea412232D84099({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7L7 1L13 7",
    stroke: "#424143",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg39Bdbd3D6Dd984Bb089Adc962360313Ddb8583124Ff2D09951Ea412232D84099);
export default __webpack_public_path__ + "static/media/39bdbd3d6dd984bb089adc962360313ddb8583124ff2d09951ea412232d84099.c147d7b1e21e86e7a87167a5ec3b5f24.svg";
export { ForwardRef as ReactComponent };